import { render } from "./Slide.vue?vue&type=template&id=ed2e2574&scoped=true"
import script from "./Slide.vue?vue&type=script&lang=js"
export * from "./Slide.vue?vue&type=script&lang=js"

import "./Slide.vue?vue&type=style&index=0&id=ed2e2574&scoped=true&lang=css"

import exportComponent from "/Users/user/Desktop/Проекты/territory_transport/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed2e2574"]])

export default __exports__